import { RevenuePaymentTypeFilter } from '@trnsact/trnsact-shared-types';
import { FinanceFilters, FinanceFilterType } from './types';

export const initialFinanceFiltersValue: FinanceFilters = {
  [FinanceFilterType.DEAL_DATE]: 'cm',
  [FinanceFilterType.SALES_REP]: [],
  [FinanceFilterType.LOCATION]: [],
  [FinanceFilterType.PAYMENT_TYPE]: RevenuePaymentTypeFilter.All,
  [FinanceFilterType.DEAL_STATUS]: 'ALL',
};
